export default "__VITE_ASSET__NHA12Rtk__"